import React from 'react';
import '../styling/Medias.scss';

const Medias = () => (
  <div className="medias">
    Espace Médias under construction
  </div>
);

export default Medias;
